(function () {
  function initCustomerServiceTabs() {
    const tabMenu = document.querySelector('.tabbmeny');
    const tabs = document.querySelectorAll('.tabbmeny li');
    const panes = document.querySelectorAll('.tab-content .tab-pane');
    const contactTarget = document.querySelector('.slot--contact-form[slot="contact-form"]');
    
    if (!tabMenu || !tabs.length || !panes.length || !contactTarget) {
      return false;
    }

    function getContactSection() {
      return document.querySelector('.contact-section');
    }

    console.log('Contact section:', getContactSection());

    const contactSection = getContactSection();

    if (contactSection && !contactTarget.contains(contactSection)) {
      contactTarget.appendChild(contactSection);
    }

    function activateTab(tab) {
      const tabClass = tab.id;
      if (!tabClass) return;

      tabs.forEach((item) => item.classList.remove('active'));
      panes.forEach((pane) => pane.classList.remove('active', 'in'));

      tab.classList.add('active');

      const targetPane = document.querySelector('.tab-content .' + tabClass);
      if (targetPane) {
        targetPane.classList.add('active', 'in');
      }
    }

    if (!tabMenu.dataset.tabsInitialized) {
      tabs.forEach((tab) => {
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          activateTab(this);
        });
      });

      tabMenu.dataset.tabsInitialized = 'true';
    }

    const activeTab = document.querySelector('.tabbmeny li.active');
    if (activeTab) {
      activateTab(activeTab);
    }

    return true;
  }

  function initWhenReady() {
    if (initCustomerServiceTabs()) {
      return;
    }

    const observer = new MutationObserver(function () {
      if (initCustomerServiceTabs()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }
})();